import imageToURI from "image-to-data-uri";
import React, { useState } from "react";

import { WrapBackgroundImage } from "./Background.styled";

const Background = (props) => {
  const [base64Convert, setBase64Convert] = useState(false);

  const { sno, cakeName, id, backgroundImagePath } = props.data;

  return (
    <WrapBackgroundImage>
      <img
        src={`${backgroundImagePath}`}
        alt={cakeName}
        width="100%"
        id={`bg_img_${sno}-${id}`}
        onLoad={() => {
          if (!base64Convert) {
            imageToURI(`${backgroundImagePath}`, (err, uri) => {
              const targetImage = document.getElementById(
                `bg_img_${sno}-${id}`
              ) as HTMLImageElement;
              if (targetImage) {
                targetImage.src = uri;
                setBase64Convert(true);
              }
            });
          }
        }}
      />

      {props.children}
    </WrapBackgroundImage>
  );
};

export default Background;



// WEBPACK FOOTER //
// ./src/components/preview/Background.tsx